angular.module("warsApp.factories").factory('clearGrowlMessagesInterceptor', ['growl',
    function (growl) {
    return {
        request: function (config) {
            //growl.deleteAllMessages();
            return config;
        }
    };
}]);